import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { API_BASE_URL } from "@config/config";


const fetchMembershipOptions = async (subscriberGroupId) => {
    const res = await axios.get(`${API_BASE_URL}/movie-club/${subscriberGroupId}`);
    return res.data.data ?? null;
};

export const useMembershipOptions = (subscriberGroupId, isPublicSite) => {
    const { data, isLoading } = useQuery({
        queryKey: ["membershipOptions", subscriberGroupId],
        queryFn: () => fetchMembershipOptions(subscriberGroupId),
        enabled: !!subscriberGroupId && isPublicSite,
        staleTime: Infinity,
    });

    return {
        membershipOptions: data ?? null,
        isMembershipLoading: isLoading,
    };
};
